import { fork, all } from "redux-saga/effects";
import { map, unary } from "lodash/fp";
import LoginSaga from "../containers/modules/Auth/saga";
import * as auth from "../containers/modules/Auth/_redux/authRedux";
import accountSaga from "../containers/Accounts/store/saga";
import senderIdSaga from "../containers/SenderId/store/saga";
import gatewayAndPriceSaga from "../containers/GatewayAndPrice/store/saga";
import gatewayNameSaga from "../containers/GatewayName/store/saga";
import campaignLiveStatusSaga from "../containers/campaign-live-status/store/saga/campaign-live-status.saga";
import campaignLiveStatusV2Saga from "../containers/campaign-live-status-v2/store/saga/campaign-live-status.saga";
import walletTransactionSaga from "../containers/Wallet-history/store/saga/transactions_saga";
import verifyNumberSaga from "../containers/Number-verify/store/saga/index.saga";
import whatsappAccountSaga from '../containers/WhatsAppAccounts/store/saga'
import adminAnalyticsSaga from "../containers/AdminAnalytics/store/saga/index";

export function* rootSaga() {
  const _sagas = [...accountSaga, ...senderIdSaga, ...gatewayAndPriceSaga, ...gatewayNameSaga, auth.saga, LoginSaga, campaignLiveStatusSaga, campaignLiveStatusV2Saga, walletTransactionSaga, verifyNumberSaga, ...whatsappAccountSaga, ...adminAnalyticsSaga];

  yield all(map(unary(fork), _sagas));
}
